import type { ARTICLE_LANGUAGES } from '../enums';
import { API } from '@Providers';

interface Payload {
  lang: ARTICLE_LANGUAGES;
}

export default async function (payload: Payload) {
  const endpoint = `/api/shelter/whats-new?lang=${payload.lang}`;

  return API({ endpoint, method: 'get' });
}
